<template>
    <!-- category_id   1.北美材 2.非洲材 -->
    <div class="printView">
        <div ref="cesh"></div>
        <div class="printTemplate" v-for="(list,index) in printTipList" :key="index">
            <div class="printTipBoxAfrica" v-if="list.category_id==2">
                <div class="bmLabelPrint" :class="['labelBox',list.config.indexOf(',border,')!=-1?'boxBorder':'']">
                    <div :class="['label_Company',list.config.indexOf(',border,')!=-1?'boxBorder_bottom':'']">
                        <span v-if="list.tpl == 1" class="label_baleNoFzT"
                            :style="{fontSize:africaSize+'px'}">{{list.bale_no}}</span>
                        <div class="label_CompanyT" v-else>
                            <div class="companyName" v-if="list.config.indexOf(',company_name,')!=-1">
                                {{list.company_name}}</div>
                            <div class="companyAddress"><span
                                    v-if="list.config.indexOf(',company_address,')!=-1">地址:{{list.company_address}}</span>
                                <span
                                    v-if="list.config.indexOf(',company_mobile,')!=-1">电话:{{list.company_mobile}}</span>
                            </div>
                        </div>
                        <img v-if="list.company_logo!=''&&list.config.indexOf(',company_logo,')!=-1"
                            :src="list.company_logo" class="label_logo" />
                    </div>
                    <div :class="['labelContent',list.tpl ==1?'labelFzContent':'']">
                        <div class="kunbao" v-if="list.tpl == 0">
                            <div class="kunbaoC" :style="{fontSize:africaSize+'px'}">{{list.bale_no}}</div>
                        </div>
                        <div :class="['labelMessBox clearfix',list.tpl==1?'fzOtherTemplate':'']">
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',breed,')!=-1">
                                <div class="labelMessKey">品名:</div>
                                <div class="labelMessValue fzValue">{{list.breed}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',brand_brand,')!=-1">
                                <div class="labelMessKey">品牌:</div>
                                <div class="labelMessValue fzValue">{{list.brand_brand}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',brand_batch_no,')!=-1">
                                <div class="labelMessKey">批次:</div>
                                <div class="labelMessValue fzValue">{{list.brand_batch_no}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',brand_attribute,')!=-1">
                                <div class="labelMessKey">属性:</div>
                                <div class="labelMessValue fzValue">{{list.brand_attribute}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',brand_pieces,')!=-1">
                                <div class="labelMessKey">片数:</div>
                                <div class="labelMessValue fzValue">{{list.brand_pieces}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',thk,')!=-1 && list.tpl == 0">
                                <div class="labelMessKey">规格:</div>
                                <div class="labelMessValue fzValue">{{list.thk}}</div>
                            </div>
                            <div class="labelMess clearfix"
                                v-if="list.config.indexOf(',length_thickness,')!=-1 && list.config.indexOf(',width,')!=-1 && list.tpl == 1">
                                <div class="labelMessKey">长度x厚度:</div>
                                <div class="labelMessValue fzValue">{{list.config.indexOf(',width,')!=-1 &&
                                    list.is_hunbao==1?'混包':list.length_thickness}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',grade_grade,')!=-1">
                                <div class="labelMessKey">等级:</div>
                                <div class="labelMessValue fzValue">{{list.grade_grade}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.config.indexOf(',grade_contract_no,')!=-1">
                                <div class="labelMessKey">合同:</div>
                                <div class="labelMessValue fzValue htValue">{{list.grade_contract_no}}</div>
                            </div>
                            <div class="labelMess clearfix" v-if="list.tpl == 0">
                                <div class="labelMessKey">材积:</div>
                                <div class="labelMessValue">{{list.original_cube}}</div>
                            </div>
                            <div class="labelMess clearfix"
                                v-if="list.config.indexOf(',layer_number,')!=-1 && (list.tpl == 0 || (list.tpl ==1 && list.config.indexOf(',width,')==-1))">
                                <div class="labelMessKey">层数:</div>
                                <div :class="['labelMessValue',list.config.indexOf(',width,')==-1?'fzValue':'']">
                                    {{list.layer_number}}</div>
                            </div>
                            <div class="labelMess clearfix thiWidth"
                                v-if="list.config.indexOf(',length_thickness,')!=-1 && list.config.indexOf(',width,')==-1 && list.tpl == 1">
                                <div class="labelMessKey">长度x厚度:</div>
                                <div class="labelMessValue fzValue">{{list.length_thickness}}</div>
                            </div>
                            <div class="labelMess clearfix widthShowView"
                                v-if="list.config.indexOf(',width,')!=-1 && list.tpl == 1">
                                <div class="messView messHalf">
                                    <div class="messView">
                                        <div class="labelMessKey">总宽度:</div>
                                        <div class="labelMessValue">{{list.total_width}}</div>
                                    </div>
                                </div>
                                <div class="messView messLeft">
                                    <div class="labelMessKey">材积:</div>
                                    <div class="labelMessValue">{{list.original_cube}}</div>
                                </div>
                                <div class="messView messRight" v-if="list.config.indexOf(',layer_number,')!=-1">
                                    <div class="labelMessKey">层数:</div>
                                    <div class="labelMessValue">{{list.layer_number}}</div>
                                </div>
                            </div>
                        </div>
                        <div :class="list.tpl==0?'labelQrCode':'labelQrCodeFz'" :id="'fz_qrcode_'+index"
                            :ref="'fz_qrcode_'+index"></div>
                        <!-- <img :src="list.qr_code" class="labelQrCode"/> -->
                    </div>
                    <div :class="['labelMess labelMessLast clearfix', list.tpl==1?'fzLabelMess':'']"
                        v-if="list.config.indexOf(',width,')!=-1">
                        <div class="labelMessKey">码单:</div>
                        <div class="labelMessValue">{{list.width}}</div>
                    </div>
                    <div :class="['labelCompanyBox', list.config.indexOf(',border,')!=-1 && list.tpl == 1?'boxBorder_top':'']"
                        v-if="list.tpl == 1">
                        <div class="leftView"
                            v-if="list.config.includes(',company_qr_code,') && list.company_qr_code !='' ">
                            <img class="userQrcode" :src="list.company_qr_code" alt="">
                        </div>
                        <div class="rightView">
                            <div class="labelCompany" v-if="list.config.includes(',company_name,')">
                                {{list.company_name}}</div>
                            <div class="labelCompanyMess">
                                <span
                                    v-if="list.config.includes(',company_address,')">地址：{{list.company_address}}</span>
                                <span
                                    v-if="list.config.indexOf(',company_mobile,')!=-1">电话：{{list.company_mobile}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="printTipBoxAmerica" v-if="list.category_id==1">
                <div class="labelBox labelPrint" v-if="list.tpl != 2">
                    <div class="label_baleNo">
                        <!-- 默认 -->
                        <span class="label_baleNoT" :style="{fontSize:defaultSize+'px'}" v-if="list.tpl == 0">
                            {{list.bale_no}}
                        </span>
                        <!-- 欧洲材 -->
                        <span class="label_baleNoT" :style="{fontSize:defaultSize+'px'}" v-else>
                            {{list.bale_no}}
                        </span>
                        <img v-if="list.company_logo!=''&&list.config.includes(',company_logo,')"
                            :src="list.company_logo" class="label_logo" />
                    </div>
                    <div class="labelMessBox clearfix" v-if="list.tpl == 0">
                        <div class="labelMess widLeft" v-if="list.config.includes(',breed_breed,')">
                            <div class="labelMessKey">Species:</div>
                            <div class="labelMessValue">{{list.breed}}</div>
                        </div>
                        <div class="labelMess widLeft" v-if="list.config.includes(',breed_attribute,')">
                            <div class="labelMessKey">Species:</div>
                            <div class="labelMessValue">{{list.attribute}}</div>
                        </div>
                        <div class="labelMess widRight" v-if="list.config.includes(',original_thickness,')">
                            <div class="labelMessKey">Thickness:</div>
                            <div class="labelMessValue">{{list.original_thickness}}</div>
                        </div>
                        <div class="labelMess widLeft" v-if="list.config.includes(',grade_grade,')">
                            <div class="labelMessKey">Grade:</div>
                            <div class="labelMessValue">{{list.grade}}</div>
                        </div>
                        <div class="labelMess widLeft" v-if="list.config.includes(',grade_code,')">
                            <div class="labelMessKey">Grade:</div>
                            <div class="labelMessValue">{{list.code}}</div>
                        </div>

                        <div class="labelMess widRight" v-if="list.config.includes(',original_length,')">
                            <div class="labelMessKey">Length:</div>
                            <div class="labelMessValue">{{list.original_length}}</div>
                        </div>
                        <div class="labelMess widLeft">
                            <div v-if="list.config.includes(',brand,')">
                                <div class="labelMessKey">Brand:</div>
                                <div class="labelMessValue">{{list.brand}}</div>
                            </div>
                            <div v-else-if="list.config.includes(',supplier,')">
                                <div class="labelMessKey">Supplier:</div>
                                <div class="labelMessValue">{{list.supplier}}</div>
                            </div>
                            <div v-else-if="list.config.includes(',pieces,')">
                                <div class="labelMessKey">Pieces:</div>
                                <div class="labelMessValue">{{list.pieces}}</div>
                            </div>
                        </div>
                        <div class="labelMess widRight">
                            <div v-if="list.config.includes(',contract_no,')">
                                <div class="labelMessKey">Contract No:</div>
                                <div class="labelMessValueBlock">{{list.contract_no}}</div>
                            </div>
                            <div v-else-if="list.config.includes(',original_bale,')">
                                <div class="labelMessKey">Bundle No:</div>
                                <div class="labelMessValueBlock">{{list.original_bale}}</div>
                            </div>
                            <div v-else-if="list.config.includes(',container_no,')">
                                <div class="labelMessKey">Container No:</div>
                                <div class="labelMessValueBlock">{{list.container_no}}</div>
                            </div>
                        </div>
                        <div class="labelQrCode" :id="'mr_qrcode_'+index" :ref="'mr_qrcode_'+index"></div>
                        <!-- <img :src="list.qr_code" v-if="list.config.includes(',qr_code,')" class="labelQrCode"/> -->
                    </div>

                    <div class="labelMessBox europe" v-else>
                        <div class="europeContent">
                            <div class="item itemLeft" v-if="list.config.includes(',breed,')">
                                <div class="labelMessKey">Species:</div>
                                <div class="labelMessValue">{{list.breed}}</div>
                            </div>
                            <div class="item itemMidden" v-if="list.config.includes(',attribute,')">
                                <div class="labelMessKey">Attribute:</div>
                                <div class="labelMessValue">{{list.attribute}}</div>
                            </div>
                            <div class="item itemRight">
                                <div class="labelMessKey">Thickness:</div>
                                <div class="labelMessValue">{{list.original_thickness}}</div>
                            </div>
                        </div>
                        <div class="europeContent">
                            <div class="item itemLeft" v-if="list.config.includes(',grade_grade,')">
                                <div class="labelMessKey">Grade:</div>
                                <div class="labelMessValue">{{list.grade}}</div>
                            </div>
                            <div class="item itemLeft" v-if="list.config.includes(',grade_code,')">
                                <div class="labelMessKey">Grade:</div>
                                <div class="labelMessValue">{{list.code}}</div>
                            </div>
                            <div class="item itemMidden">
                                <div class="labelMessKey">Length:</div>
                                <div class="labelMessValue">{{list.original_length}}</div>
                            </div>
                            <div class="item itemRight" v-if="list.config.includes(',sales_cube,')">
                                <div class="labelMessKey">Cube:</div>
                                <div class="labelMessValue">{{list.sales_cube}}</div>
                            </div>
                            <div class="item itemRight" v-if="list.config.includes(',original_cube,')">
                                <div class="labelMessKey">Cube:</div>
                                <div class="labelMessValue">{{list.original_cube}}</div>
                            </div>
                        </div>
                        <div class="europeContent">
                            <div class="item itemLeft" v-if="list.config.includes(',brand,')">
                                <div class="labelMessKey">Brand:</div>
                                <div class="labelMessValue">{{list.brand}}</div>
                            </div>
                            <div class="item itemLeft" v-if="list.config.includes(',supplier,')">
                                <div class="labelMessKey">Supplier:</div>
                                <div class="labelMessValue">{{list.supplier}}</div>
                            </div>
                            <div class="item itemMidden" v-if="list.config.includes(',pieces,')">
                                <div class="labelMessKey">Pieces:</div>
                                <div class="labelMessValue">{{list.pieces}}</div>
                            </div>
                            <div class="item itemRight bundleNo" v-if="list.config.includes(',contract_no,')">
                                <div class="labelMessKey">Contract No:</div>
                                <div class="labelMessValue">{{list.contract_no}}</div>
                            </div>
                            <div class="item itemRight bundleNo" v-if="list.config.includes(',original_bale,')">
                                <div class="labelMessKey">Bundle No:</div>
                                <div class="labelMessValue">{{list.original_bale}}</div>
                            </div>
                            <div class="item itemRight bundleNo" v-if="list.config.includes(',container_no,')">
                                <div class="labelMessKey">Container No:</div>
                                <div class="labelMessValue">{{list.container_no}}</div>
                            </div>
                        </div>
                        <div class="labelQrCode" :id="'oz_qrcode_'+index" :ref="'oz_qrcode_'+index"></div>
                        <!-- <img :src="list.qr_code" v-if="list.config.includes(',qr_code,')" class="labelQrCode"/> -->
                    </div>
                    <div class="labelCompanyBox">
                        <div class="leftView"
                            v-if="list.config.includes(',company_qr_code,') && list.company_qr_code !='' ">
                            <img class="userQrcode" :src="list.company_qr_code" alt="">
                        </div>
                        <div class="rightView">
                            <div class="labelCompany" v-if="list.config.includes(',company_name,')">
                                {{list.company_name}}</div>
                            <div class="labelCompanyMess"><span
                                    v-if="list.config.includes(',company_address,')">地址：{{list.company_address}}</span>
                                <span
                                    v-if="list.config.indexOf(',company_mobile,')!=-1">电话：{{list.company_mobile}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="labelBox labelPrint labelPrintHs" v-if="list.tpl == 2"
                    :style="{'width':`${list.tag_width*0.95}cm`,'height':`${list.tag_height*0.95}cm`}">
                    <span v-if="list.config.includes(',bale_no,')" class="hsBaleNo"
                        :style="{fontSize:defaultSize+'px','left':`${list.bale_x}%`,'top':`${list.bale_y}%`}">{{list.bale_no}}</span>
                    <div class="hsBoxBack" v-if="list.config.includes(',qr_code,')" :style="{
                        'width':qrCodeWidthStyle,
                        'height':qrCodeWidthStyle,
                    }">
                        <div class="labelQrCodeSh" :id="'hs_qrcode_'+index" :ref="'hs_qrcode_'+index"
                            :style="{'left':`${list.qrcode_x}%`,'top':`${list.qrcode_y}%`}"></div>
                    </div>
                    <img class="hsImage" :src="list.background_tag" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import QRCode from 'qrcodejs2';
    export default {
        data() {
            return {
                // 北美材 默认 欧洲材 size
                // defaultSize:localStorage.getItem('defaultSize'),
                // europeSize:localStorage.getItem('europeSize'),
                defaultSize: '',
                europeSize: '',
                africaSize: '',
                ids: [],
                field: [],
                sort: [],
                type: 0,
                printTipList: [
                    { config: "" }
                ],
            }
        },
        computed: {
            qrCodeWidthStyle() {
                let size = '100%';
                if (this.printTipList && this.printTipList.length > 0) {
                    let wid = undefined;
                    this.printTipList.forEach(item => {
                        if (item.qrcode_size) {
                            wid = item.qrcode_size;
                        }
                    })
                    if (wid != undefined) {
                        size = `calc(100% - ${wid + 2}px)`;
                    }
                }
                return size
            },
        },
        created() {
            this.ids = this.$route.query.ids;
            this.field = this.$route.query.field;
            this.sort = this.$route.query.sort;
            this.getData();
        },
        mounted() {

        },
        methods: {
            getData() {
                let obj = {};
                obj.id = this.ids;
                if (this.field != "undefined" && this.field != "") {
                    obj.field = this.field;
                }
                if (this.sort != "undefined" && this.sort != "") {
                    obj.sort = this.sort;
                }
                this.postFunc("/erp/inventory.print.tag", obj, res => {
                    this.printTipList = res.data.data;
                    this.printTipList.forEach((item, index) => {
                        item.config = "," + (item.config.join(",")).toString() + ",";
                        if (item.category_id == 1) {
                            this.defaultSize = item.bale_size;
                            if (item.tpl == 0) {
                                setTimeout(() => {
                                    let refName = {
                                        width: 125,
                                        height: 125,
                                        ref: document.getElementById("mr_qrcode_" + index)
                                    };
                                    this.creatQrCode(item.qr_code, refName);
                                }, 1)
                            } else if (item.tpl == 1) {
                                setTimeout(() => {
                                    let refName = {
                                        width: 125,
                                        height: 125,
                                        ref: document.getElementById("oz_qrcode_" + index)
                                    };
                                    this.creatQrCode(item.qr_code, refName);
                                }, 1)
                            } else if (item.tpl == 2) {
                                setTimeout(() => {
                                    let refName = {
                                        width: item.qrcode_size,
                                        height: item.qrcode_size,
                                        ref: document.getElementById("hs_qrcode_" + index)
                                    };
                                    this.creatQrCode(item.qr_code, refName);
                                }, 1)
                            }
                        } else if (item.category_id == 2) {
                            this.africaSize = item.bale_size;
                            setTimeout(() => {
                                let refName = {
                                    width: item.tpl == 0 ? 170 : 140,
                                    height: item.tpl == 0 ? 170 : 140,
                                    ref: document.getElementById("fz_qrcode_" + index)
                                };
                                this.creatQrCode(item.qr_code, refName);
                            }, 1)
                        }

                    })

                    setTimeout(() => {
                        this.printFunc()
                    }, 100);
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            printFunc() {
                setTimeout(() => {
                    if (!!window.netscape) {
                        window.print()
                        setTimeout(() => { window.close() }, 0);
                    } else {
                        var tata = document.execCommand("print");
                        if (tata) {  //点击取消后执行的操作
                            window.close()
                        }
                    }
                }, 0);
            },

            creatQrCode(text, refName) {
                new QRCode(refName.ref, {
                    text: text, // 需要转换为二维码的内容
                    width: refName.width,
                    height: refName.height,
                    // colorDark: '#000000',
                    // colorLight: '#ffffff',
                    // correctLevel: QRCode.CorrectLevel.H
                })
            },
        }
    }
</script>
<style scoped>
    .boxBorder {
        border: 1px solid #000;
    }

    .boxBorder_bottom {
        border-bottom: 1px solid #000;
    }

    .boxBorder_top {
        border-top: 1px solid #000;
    }

    .printTipBoxAfrica {
        width: 14.25cm;
    }

    .printTipBoxAfrica .labelBox {
        width: 14.25cm;
        height: 9.5cm;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        margin: auto;
        page-break-after: always;
    }

    .printTipBoxAfrica .bmLabelPrint {
        margin-top: 10px;
        margin-left: 0;
    }

    .printTipBoxAfrica .label_baleNo {
        font-size: 98px;
        font-weight: 600;
        text-align: center;
        border-bottom: 1px solid #000;
        position: relative;
        line-height: 130px;
    }

    .printTipBoxAfrica .label_baleNoT {
        position: relative;
        z-index: 1;
    }

    .printTipBoxAfrica .label_baleNoFzT {
        position: absolute;
        z-index: 1;
        left: 83px;
        height: 100%;
        text-align: center;
        display: inline-block;
        width: 453px;
        font-weight: 600;
    }

    .printTipBoxAfrica .label_Company {
        position: relative;
        height: 3cm;
    }

    .printTipBoxAfrica .label_CompanyT {
        position: absolute;
        bottom: 0;
        right: 10px;
    }

    .printTipBoxAfrica .label_CompanyT .companyName {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        padding-bottom: 5px;
    }

    .printTipBoxAfrica .label_CompanyT .companyAddress {
        font-size: 14px;
        text-align: right;
        padding-bottom: 10px;
    }

    .printTipBoxAfrica .label_CompanyT .companyAddress span {
        margin-left: 15px;
    }

    .printTipBoxAfrica .labelContent {
        position: relative;
        padding-right: 180px;
    }

    .printTipBoxAfrica .labelFzContent {
        padding-right: 160px;
    }

    .printTipBoxAfrica .labelMessBox {
        padding: 0 10px;
        position: relative;
        height: 105px;
        box-sizing: border-box;
        padding-bottom: 0;
    }

    .printTipBoxAfrica .kunbao {
        width: 100%;
        padding: 5px 10px;
        box-sizing: border-box;
        text-align: left;
    }

    .printTipBoxAfrica .kunbaoC {
        display: inline-block;
        background-color: #dcd9d9;
        padding: 0px 10px;
        min-width: 200px;
        text-align: center;
        font-weight: 600;
    }

    .printTipBoxAfrica .labelMess {
        float: left;
        text-align: left;
        margin-bottom: 5px;
        width: 50%;
        height: 30px;
        display: flex;
        padding-right: 2px;
    }

    .printTipBoxAfrica .labelMess:nth-child(2n) {
        float: right;
    }

    .printTipBoxAfrica .labelMessLast {
        width: 100%;
        padding-left: 10px;
    }

    .printTipBoxAfrica .labelMessLast .labelMessValue {
        font-size: 12px;
    }

    .printTipBoxAfrica .labelMessKey {
        display: block;
        font-size: 12px;
        float: left;
        line-height: 45px;
        margin-right: 5px;
    }

    .printTipBoxAfrica .labelMessValue {
        display: block;
        font-size: 18px;
        font-weight: 600;
        line-height: 30px;
        word-break: break-all;
        border-bottom: 1px solid #000;
        float: left;
        flex: 1;
    }

    /* 非洲材其他模版 */
    .printTipBoxAfrica .fzOtherTemplate {
        height: 167px;
        padding: 7px 0px 0 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .printTipBoxAfrica .fzOtherTemplate .labelMess {
        width: 50%;
        float: none;
        display: flex;
        flex-direction: column;
        height: auto;
        margin-bottom: 12px;
    }

    .printTipBoxAfrica .fzOtherTemplate .labelMess .labelMessKey {
        line-height: normal;
        float: none;
    }

    .printTipBoxAfrica .fzOtherTemplate .labelMess .labelMessValue {
        float: none;
        border-bottom: 0 !important;
        margin-left: 6px;
        line-height: 30px;
        word-break: break-all;
        /* white-space: nowrap; */
        /* overflow: hidden; */
        /* text-overflow: ellipsis; */
    }

    .printTipBoxAfrica .fzOtherTemplate .labelMess .htValue {
        white-space: nowrap;
        overflow: hidden;
    }

    .printTipBoxAfrica .fzOtherTemplate .labelMess .fzValue {
        font-size: 31px;
    }

    .printTipBoxAfrica .fzLabelMess {
        float: none;
        margin-bottom: 0;
        height: 30px;
    }

    .printTipBoxAfrica .fzLabelMess .labelMessKey {
        line-height: 30px;
    }

    .printTipBoxAfrica .fzLabelMess .labelMessValue {
        border: 0 !important;
    }

    .printTipBoxAfrica .labelMessLong {
        width: 100%;
        text-align: left;
        float: left;
    }

    .printTipBoxAfrica .labelMessValueLong {
        display: inline;
        font-size: 25px;
        font-weight: 600;
    }

    .printTipBoxAfrica .labelQrCode {
        width: 170px;
        height: 170px;
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .printTipBoxAfrica .labelQrCodeFz {
        width: 140px;
        height: 140px;
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .printTipBoxAfrica .labelCompanyBox {
        text-align: center;
        padding-top: 3px;
        display: flex;
        flex-direction: row;
        height: 47px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .printTipBoxAfrica .labelCompanyBox .leftView {
        flex-basis: 56px;
    }

    .printTipBoxAfrica .labelCompanyBox .leftView .userQrcode {
        width: 40px;
        height: 40px;
    }

    .printTipBoxAfrica .labelCompanyBox .rightView {
        flex: 1;
    }

    .printTipBoxAfrica .labelCompany {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .printTipBoxAfrica .labelCompanyMess {
        font-size: 12px;
    }

    .printTipBoxAfrica .labelCompanyMess span {
        margin-right: 10px;
    }

    .printTipBoxAfrica .label_logo {
        width: 75px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 10px;
        margin: auto;
        z-index: 0;
    }

    .printTipBoxAfrica .fzOtherTemplate .thiWidth {
        width: 100%;
    }

    .printTipBoxAfrica .fzOtherTemplate .widthShowView {
        display: flex;
        flex-direction: row;
        width: 100%;
        padding-right: 0;
    }

    .printTipBoxAfrica .fzOtherTemplate .widthShowView .messView {
        display: flex;
        flex-direction: column;
        padding-right: 10px;
    }

    .messHalf {
        width: 50%;
    }

    .messLeft {
        width: 30%;
    }

    .messRight {
        width: 20%;
    }

    .printTipBoxAmerica .printTemplate {
        width: 14.25cm;
        height: 9.5cm;
        box-sizing: border-box;
        overflow: hidden;
        margin: auto;
        position: relative;
        color: #000;
        page-break-after: always;
    }

    .printTipBoxAmerica .labelBox {
        background-color: #fff;
        border: 1px solid #000;
        display: block;
        width: 14.25cm;
        height: 9.4cm;
        box-sizing: border-box;
        overflow: hidden;
        margin: auto;
        page-break-after: always;
    }

    .printTipBoxAmerica .labelPrint {
        margin-top: 10px;
        margin-left: 0;
    }

    .printTipBoxAmerica .labelPrintHs {
        position: relative;
        border: 0;
        padding: 1px;
    }

    .printTipBoxAmerica .labelPrintHs .hsBoxBack {
        position: relative;
        z-index: 30;
        width: 100%;
        height: 100%;
    }

    .printTipBoxAmerica .labelPrintHs .hsBaleNo {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 110;
    }

    .printTipBoxAmerica .labelPrintHs .labelQrCodeSh {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 100;
    }

    .printTipBoxAmerica .labelPrintHs .hsImage {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        z-index: 20;
        left: 1px;
        top: 1px;
    }

    .printTipBoxAmerica .label_baleNo {
        height: 130px;
        font-size: 98px;
        font-weight: 600;
        text-align: center;
        border-bottom: 1px solid #000;
        position: relative;
        line-height: 130px;
    }

    .printTipBoxAmerica .label_baleNoT {
        position: absolute;
        z-index: 1;
        left: 84px;
        font-size: 90px;
        text-align: center;
        display: inline-block;
        width: 453px;
    }

    .printTipBoxAmerica .labelMessBox {
        padding: 7px 128px 45px 3px;
        position: relative;
        border-bottom: 1px solid #000;
        height: 175px;
        box-sizing: border-box;
    }

    .printTipBoxAmerica .labelMess {
        float: left;
        text-align: left;
        margin-bottom: 5px;
        width: 50%;
        height: 50px;
    }

    .printTipBoxAmerica .labelMess:nth-child(2n) {
        float: right;
    }

    .printTipBoxAmerica .labelMessBox .labelMess.widLeft {
        width: 57%;
    }

    .printTipBoxAmerica .labelMessBox .labelMess.widRight {
        width: 43%;
    }

    .printTipBoxAmerica .labelBottomBox {
        width: 100%;
        height: 40px;
        position: absolute;
        display: flex;
        bottom: 0;
        text-align: left;
    }

    .printTipBoxAmerica .labelBottomBox .labelBottomItemLeft {
        width: 45%;
    }

    .printTipBoxAmerica .labelBottomBox .labelBottomItemRight {
        width: 55%;
    }

    .printTipBoxAmerica .labelMessKey {
        display: inline;
        font-size: 12px;
    }

    .printTipBoxAmerica .labelMessValue {
        font-size: 31px;
        font-weight: 600;
        line-height: 30px;
        word-break: break-all;
        margin-left: 6px;
    }

    .printTipBoxAmerica .labelMessLong {
        width: 100%;
        text-align: left;
        float: left;
    }

    .printTipBoxAmerica .labelMessValueBlock {
        width: 100%;
        font-size: 31px;
        line-height: 30px;
        font-weight: 600;
        white-space: nowrap
    }

    .printTipBoxAmerica .labelMessValueLong {
        display: inline;
        font-size: 25px;
        font-weight: 600;
    }

    .printTipBoxAmerica .labelQrCode {
        width: 125px;
        height: 125px;
        position: absolute;
        top: 3px;
        right: 3px;
    }

    .printTipBoxAmerica .labelCompanyBox {
        text-align: center;
        padding-top: 3px;
        display: flex;
        flex-direction: row;
        height: 47px;
    }

    .printTipBoxAmerica .labelCompanyBox .leftView {
        flex-basis: 56px;
    }

    .printTipBoxAmerica .labelCompanyBox .leftView .userQrcode {
        width: 42px;
        height: 42px;
    }

    .printTipBoxAmerica .labelCompanyBox .rightView {
        flex: 1;
    }

    .printTipBoxAmerica .labelCompany {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .printTipBoxAmerica .labelCompanyMess {
        font-size: 12px;
    }

    .printTipBoxAmerica .labelCompanyMess span {
        margin-right: 10px;
    }

    .printTipBoxAmerica .label_logo {
        width: 75px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 10px;
        margin: auto;
        z-index: 0;
    }

    .printTipBoxAmerica .europe {
        padding: 7px 128px 45px 3px;
        position: relative;
        border-bottom: 1px solid #000;
        height: 175px;
        box-sizing: border-box;
    }

    .printTipBoxAmerica .europe .europeContent {
        display: flex;
    }

    .printTipBoxAmerica .europe .europeContent .item {
        text-align: left;
        width: 33%;
        float: left;
        padding: 0 0 0 10px;
    }

    .printTipBoxAmerica .europe .europeContent .item:nth-child(1) {
        width: 35%;
    }

    .printTipBoxAmerica .europe .europeContent .item:nth-child(2) {
        width: 32%;
    }

    .printTipBoxAmerica .europe .europeContent .item:nth-child(3) {
        width: 30%;
    }

    .printTipBoxAmerica .europe .europeContent .bundleNo .labelMessValue {
        white-space: nowrap;
    }

    .printView {
        display: none;
    }

    @media print {
        .printView {
            display: block;
        }
    }

    /* .print{color:#000;} */
    /* .printTipBox{background-color: #fff;position: relative;display:block;width:14.25cm;height:9.5cm;border-bottom:1px dotted #000;margin: auto;}
    .tipNameBox{text-align: center;padding-bottom:5px;}
    .tipNameBoxB{border-bottom:2px solid #000;}
    .tipbale_no{font-size: 75px;font-weight: 600;font-family: fantasy;}
    .tipNameA{font-size: 30px;font-weight: 600;}
    .tipNameB{font-size: 45px;font-weight: 600;}
    .printTipBox .mess{position: relative;padding:8px 0;padding-right:180px;box-sizing: border-box;}
    .printTipBox .messB{border-bottom:2px solid #000;padding:0px 0;padding-right:180px;}
    .printTipBox .messC{padding:0px 0;padding-right:180px;margin-top:10px;}
    .tipImage{width:155px;height:155px;position: absolute;top:0px;right:10px;bottom:0;margin:auto;}
    .detail{min-width: 40%; height:41px;text-align: left;font-size: 28px;margin-bottom:10px;padding-left:10px;box-sizing: border-box;margin-right:35px;}
    .detail:nth-child(2n){margin-right: 0;}
    .detail .detailContent{font-weight: 600;}
    .tipDetailA .detail{margin-bottom:25px;float: left;}
    .tipDetailB .detail{float:left;}
    .tipDetailB .detailA{width:100%;}
    .tipDetail .detail:last-child{margin-bottom:0;}
    .printBottomCB{text-align: right;padding:0 10px;margin-top:5px;}
    .printBottomCB .printBottom{display: inline-block;text-align: left;}
    .printBottomCB .bottomMess{font-size: 12px;padding:1px 0;}
    .printBottomCF{padding:0 10px;margin-top:5px;font-size: 12px;text-align: left;}
    .detailContentT{font-size: 12px;}
    .detailbeimei{height: 35px!important;position: relative;padding-left:50px;box-sizing: border-box;}
    .detailContentTP{position: absolute;width:50px;text-align: right;top:50%;transform: rotateY(-50%);left:0;}
    .detailbeimeiC{padding-left:80px;}
    .detailContentTPC{width:80px;} */
</style>